<span *ngIf="sign" class="points-tag-sign ods-typography-body-s-bold">{{ sign }}</span>
<div class="points-tag-content ods-typography-microcopy-bold">
  {{ tagContent }}
</div>
